import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { DrawerCard, DrawerInfoGrid, DrawerInfoRow } from '../../DrawerComponents'
import GlossaryTooltip, { getTermID } from '../../GlossaryTooltip/GlossaryTooltip'

export const CallDetailsCard = ({ selectedRow }) => {
  const { t } = useTranslation()

  if (!selectedRow) return null

  const callType = selectedRow[4] === 'Manual' ? t('calls.outbound') : selectedRow[4] || t('common.na')
  const handleTime = selectedRow[9] || t('common.na')
  const disposition = selectedRow[13] || t('common.na')
  const timestamp = selectedRow[0] || t('common.na')

  const direction = selectedRow[4]
  const phoneNumber = selectedRow[1] || t('common.na')
  const campaignName = selectedRow[5] || t('common.na')
  const customerName = selectedRow[17] || t('common.na')
  const customerCompany = selectedRow[18] || t('common.na')
  const agentName = selectedRow[6] || t('common.na')

  const fromValue = direction === 'Outbound' ? campaignName : phoneNumber
  const toValue = direction === 'Inbound' ? campaignName : phoneNumber

  return (
    <DrawerCard
      title={t('calls.drawer.callInformation')}
      icon="phone"
      collapsible={false}
    >
      <DrawerInfoGrid columns={3}>
        <DrawerInfoRow label={t('calls.table.timestamp')} value={timestamp} />
        <DrawerInfoRow label={t('calls.table.callType')} value={callType} />
        <DrawerInfoRow label={t('calls.table.handleTime')} value={handleTime} />
        <DrawerInfoRow
          label={t('calls.disposition')}
          value={
            <GlossaryTooltip termId={getTermID(disposition)}>
              {disposition}
            </GlossaryTooltip>
          }
        />
        <DrawerInfoRow label={t('calls.table.from')} value={fromValue} />
        <DrawerInfoRow label={t('calls.table.to')} value={toValue} />
        <DrawerInfoRow label={t('calls.table.customerName')} value={customerName} />
        <DrawerInfoRow label={t('calls.table.customerCompany')} value={customerCompany} />
        <DrawerInfoRow label={t('calls.table.agentName')} value={agentName} />
      </DrawerInfoGrid>
    </DrawerCard>
  )
}

CallDetailsCard.propTypes = {
  selectedRow: PropTypes.object
}

export default CallDetailsCard
